export function isSelectOverlayTarget(target: EventTarget | null): boolean {
  return (
    target instanceof HTMLElement
    && Boolean(
      target.closest(
        ".ibada-select__menu, .ibada-select__menu-portal, .ibada-select__menu-list, .ibada-select__option, .ibada-select__group, .ibada-select__group-heading, .ibada-select__no-options-message",
      ),
    )
  )
}
